export default "__VITE_ASSET__LPDuosfZ__"